import serverUrl from "api/ServerUrl";

const AUTH_TOKEN_URL = `${serverUrl}auth/token/`;
const AUTH_PASSWORD_RESET_URL = `${serverUrl}auth/password-reset/`;
const USERS_URL = `${serverUrl}users/`;
const USERS_ORGANIZATIONS = `${serverUrl}organizations`;
const UPDATE_PROFILE_URL = `${serverUrl}update_user_profile`;
const GET_PROFILE_DATA_URL = `${serverUrl}verify_user`;
const SEND_EMAIL_URL = (userId) => `${serverUrl}users/${userId}/send-mail/`;
const LOCK_USERS_URL = `${serverUrl}userprofiles/`;

export default {
  AUTH_TOKEN_URL,
  UPDATE_PROFILE_URL,
  GET_PROFILE_DATA_URL,
  USERS_URL,
  LOCK_USERS_URL,
  AUTH_PASSWORD_RESET_URL,
  SEND_EMAIL_URL,
  USERS_ORGANIZATIONS,
};
